import { render, staticRenderFns } from "./InformationAdd.vue?vue&type=template&id=7a6474d8&scoped=true&"
import script from "./InformationAdd.vue?vue&type=script&lang=js&"
export * from "./InformationAdd.vue?vue&type=script&lang=js&"
import style0 from "./InformationAdd.vue?vue&type=style&index=0&id=7a6474d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6474d8",
  null
  
)

export default component.exports